import { Loading } from '@fasstech/middle-design-system';
import SouscriptionWaiverStagesForm from './SouscriptionWaiverStagesForm';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import useGetSouscriptionWaiverStagesGranteesQuery from './hooks/useGetSouscriptionWaiverStagesGranteesQuery';
import useGetSouscriptionWaiverStagesQuery from './hooks/useGetSouscriptionWaiverStagesQuery';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';

const SouscriptionWaiverStages = ({ getMiddleText, getMiddleBoolean, viewMode }) => {
  const {
    getSouscriptionWaiverStagesGrantees,
    loading: isFetchingGetSouscriptionWaiverStagesGrantees
  } = useGetSouscriptionWaiverStagesGranteesQuery();

  const { getSouscriptionWaiverStages, loading: isFetchingGetSouscriptionWaiverStages } =
    useGetSouscriptionWaiverStagesQuery();

  if (isFetchingGetSouscriptionWaiverStages || isFetchingGetSouscriptionWaiverStagesGrantees) {
    return <Loading />;
  }

  return (
    <div>
      <SouscriptionWaiverStagesForm
        getGrantees={getSouscriptionWaiverStagesGrantees}
        getOffer={getSouscriptionWaiverStages}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        viewMode={viewMode}
      />
    </div>
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionWaiverStages);
